import { Button, Box } from "@mui/material";
import SortableTable from "../../../../../App/Components/Table/SortableTable";
import Modal from "../../../../../App/Components/Modals/Modal";
import ModalForm from "../../../../../App/Components/Modals/Components/ModalForm";
import { useModalHooks } from "../../../../../App/State/Hooks/useModalHooks";
import useAbacFeaturesState from "./State/FeaturesState";
import { IApp } from "../../../../../App/Typings/AbacApp";
import FeatureTableCell from "./Components/FeatureTableCell";
import CreateFeatureForm from "./Components/CreateFeatureForm";

interface IFeatureProps {
  app: IApp;
}

export function Features({ app }: IFeatureProps) {
  const {
    getters: {
      features,
      columns,
      isFeatureListLoading,
      createFeatureModalTitle,
      createIsLoading,
      formik,
    },
    handlers: { handleCreateModalClose },
  } = useAbacFeaturesState(app);

  const { modalStatus, openModal } = useModalHooks();

  return (
    <>
      <Box>
        <Box
          sx={{
            width: "100%",
            position: "relative",
          }}
        >
          <Button
            variant="contained"
            color="primary"
            sx={{
              position: "absolute",
              right: "0px",
              top: "0px",
              left: { xs: "0px", sm: "unset" },
            }}
            onClick={() => openModal()}
          >
            Create Feature
          </Button>
        </Box>
        <Box
          sx={{
            pt: { xs: "3rem", sm: "unset" },
          }}
        >
          <SortableTable
            columns={columns}
            tableData={features}
            rowComponent={FeatureTableCell}
            loading={isFeatureListLoading}
            hideSearch={false}
            defaultSortIndex={0}
            setTableData={undefined}
            reverse={false}
            customProps={undefined}
          />
        </Box>
      </Box>
      <Modal
        fullWidth
        maxWidth="sm"
        open={modalStatus.open === true}
        title={createFeatureModalTitle}
        hasLoadingBar={true}
        isProcessing={createIsLoading}
        handleClose={() => handleCreateModalClose()}
      >
        <ModalForm formik={formik} isProcessing={createIsLoading}>
          <CreateFeatureForm />
        </ModalForm>
      </Modal>
    </>
  );
}
